import { useInView } from 'react-intersection-observer';

interface UseIsElementInScreenViewInput {
  threshold?: number;
  onChange?: (inView: boolean) => void;
  triggerOnce?: boolean;
  rootMargin?: string;
}

const useIsElementInScreenView = (
  input: UseIsElementInScreenViewInput = {},
): [(node?: Element | null | undefined) => void, boolean] => {
  const { ref, inView } = useInView({
    threshold: input.threshold,
    triggerOnce: input.triggerOnce ?? true,
    onChange: input.onChange,
    rootMargin: input.rootMargin ?? undefined,
  });

  return [ref, inView];
};

export default useIsElementInScreenView;
